import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class NotificationService {

  constructor(private toastr: ToastrService) { }

 
//Afficher le message de succès
showSuccess(message: string, title: string, timeOut: any){
  this.toastr.success(message, title, {
    timeOut: timeOut,
    progressBar: true,
    progressAnimation: "increasing",
  })
}


//Afficher le message d'erreur
showError(message: string, title: string, timeOut: any){
  this.toastr.error(message, title, {
    timeOut: timeOut,
    progressBar: true,
    progressAnimation: "increasing",
  })
}

//Afficher le message d'avertissement
showWarning(message: string, title: string, timeOut: any){
  this.toastr.warning(message, title, {
    timeOut: timeOut,
    progressBar: true,
    progressAnimation: "increasing",
  })
}


}



// WEBPACK FOOTER //
// ./src/app/notification.service.ts